import {ContentContainer} from '@coolcolduk/ui-mui';
import {ArrowBack} from '@mui/icons-material';
import {Box, Button, Stack, Typography} from '@mui/material';

export interface AdminQuestionViewNotFoundProps {
  onBack: () => void;
}

export default function AdminQuestionViewNotFound({onBack}: AdminQuestionViewNotFoundProps) {
  return (
    <ContentContainer data-testid="admin-question-view-not-found-page">
      <Stack direction="row" alignItems="center" spacing={2} sx={{mb: 3}}>
        <Button
          startIcon={<ArrowBack />}
          onClick={onBack}
          sx={{
            color: '#1B263B',
            '&:hover': {bgcolor: 'rgba(27, 38, 59, 0.04)'},
          }}
        >
          Back to Questions
        </Button>
      </Stack>
      <Box sx={{display: 'flex', justifyContent: 'center', p: 4}}>
        <Typography variant="body1" color="text.secondary">
          Question not found. Please go back and select a question.
        </Typography>
      </Box>
    </ContentContainer>
  );
}
